<template>
  <a-menu mode="horizontal" class="menu" :selectedKeys="[selectedKey]">
    <a-menu-item v-if="username" key="Home"><router-link to="/"><a-icon type="home" /> Home</router-link></a-menu-item>
    <a-sub-menu v-if="username">
      <span slot="title" class="submenu-title-wrapper"
        ><a-icon type="database" />Dữ liệu</span
      >
      <a-menu-item key="XAccount">
        <router-link to="/data/x-accounts">
          <a-icon type="twitter" /> Tài khoản X
        </router-link>
      </a-menu-item>
      <a-menu-item key="FbAccount">
        <router-link to="/data/fb-accounts">
          <a-icon type="facebook" /> Tài khoản Facebook
        </router-link>
      </a-menu-item>
      <a-menu-item key="HotmailAccount">
        <router-link to="/data/hotmail-accounts">
          <a-icon type="mail" /> Tài khoản Hotmail
        </router-link>
      </a-menu-item>
    </a-sub-menu>
    <a-sub-menu v-if="username">
      <span slot="title" class="submenu-title-wrapper"
        ><a-icon type="schedule" />Công việc</span
      >
      <a-menu-item key="CreateJob">
        <router-link to="/jobs/create">
          <a-icon type="plus-circle" /> Tạo mới
        </router-link>
      </a-menu-item>
      <a-menu-item key="ListJob">
        <router-link to="/jobs">
          <a-icon type="unordered-list" /> Danh sách
        </router-link>
      </a-menu-item>
    </a-sub-menu>
    <a-sub-menu>
      <span slot="title" class="submenu-title-wrapper"
        ><a-icon type="setting" />Cài đặt</span
      >
      <a-menu-item key="ServiceSetting">
        <router-link to="/settings/service">
          <a-icon type="global" /> Cài đặt service
        </router-link>
      </a-menu-item>
      <a-menu-item key="XCookiesSetting">
        <router-link to="/settings/x-cookies">
          <a-icon type="copyright" /> Cài đặt X-Cookies (checklive)
        </router-link>
      </a-menu-item>
    </a-sub-menu>
    
    <a-sub-menu class="menu-right">
      <span slot="title" class="submenu-title-wrapper"
        ><a-icon type="user" />{{username || 'Guest'}}</span
      >
      <a-menu-item v-if="username" key="LoginPage" @click="logout">
        <a-icon type="logout" /> Đăng xuất
      </a-menu-item>
      <a-menu-item v-if="!username" key="LoginPage">
        <router-link to="/auth/login">
          <a-icon type="login" /> Đăng nhập
        </router-link>
      </a-menu-item>
    </a-sub-menu>

    <a-sub-menu class="menu-right">
      <span slot="title" class="submenu-title-wrapper">
        <IconCpu/>&nbsp; {{parseInt(metrics.cpu)}}%
        &nbsp; - &nbsp;
        <IconRam/>&nbsp; {{parseInt(metrics.memory)}}%
        &nbsp; - &nbsp;
        <a-icon type="clock-circle" />{{(metrics.uptime / 3600).toFixed(2)}}h
      </span>
    </a-sub-menu>
  </a-menu>
</template>

<style scoped>
.menu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  padding: 0 25px !important;
}

.menu-right {
  float: right;
  margin-left: auto;
}
</style>

<script>
import { mapGetters, mapActions } from 'vuex';
import IconCpu from '../icons/IconCpu.vue';
import IconRam from '../icons/IconRam.vue';

export default {
  name: 'NavigationLayout',
  components: {
    IconCpu,
    IconRam
  },
  data() {
    return {
      metrics: {
        cpu: 0,
        memory: 0,
        uptime: 0,
      }
    }
  },
  computed: {
    ...mapGetters("auth", {
      username: "getUsername"
    }),

    selectedKey() {
      return this.$route.name;
    }
  },
  created() {
    this.fetchMetrics();

    setInterval(() => {
      this.fetchMetrics();
    }, 2000);
  },
  methods: {
    ...mapActions("auth", {
      removeSession: "removeSession"
    }),

    ...mapActions('serviceActuator', {
      getMetrics: "getMetrics"
    }),

    async fetchMetrics() {
      const metrics = await this.getMetrics();

      this.metrics = metrics;
    },

    logout() {
      this.removeSession();
      this.$router.push({name: 'LoginPage'});
    }
  }
}
</script>